import { ReferenceManyField, Datagrid, TextField, DateField, useRecordContext, SimpleShowLayout } from "react-admin";
import get from "lodash/get";
import JSONPretty from "react-json-pretty";
import React, { useState, Fragment } from "react";
import {
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  IconButton,
  Collapse,
  Stack,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TruncatedTextField } from "./TruncatedTextField";

export const ChangelogShow = ({ ...props }) => {
  const record = useRecordContext(props);
  var changes = get(record, "after");
  var before = get(record, "before");

  return (
    <SimpleShowLayout>
      <JSONPretty data={changes} label="Changes" themeClassName="custom-json-pretty"></JSONPretty>
      <JSONPretty data={before} label="Before" themeClassName="custom-json-pretty"></JSONPretty>
    </SimpleShowLayout>
  );
};

export const Changelog = (props) => {
  return (
    <ReferenceManyField label="Changelog" reference="changelog" target="id" filter={{ from: props.from }}>
      <Datagrid
        label="Changelog"
        bulkActionButtons={false}
        expand={<ChangelogShow {...props} />}
        style={{ tableLayout: "fixed" }}
      >
        <TruncatedTextField source="superuser_email" label="Superuser Email" data-testid={"changelog-email"} />
        <DateField source="occurred_at" showTime={true} label="Occurred at" data-testid={"changelog-date"} />
      </Datagrid>
    </ReferenceManyField>
  );
};

export const ChangelogReactRow = (props) => {
  const { entry } = props;
  const [rowOpen, setRowOpen] = useState(false);

  function getDate(timestamp) {
    let date = new Date(timestamp);
    return Intl.DateTimeFormat("en-US", { timeStyle: "medium", dateStyle: "short" }).format(date);
  }

  return (
    <Fragment>
      <TableRow key={entry.uuid} size="small">
        <TableCell size="small" style={{ paddingBottom: 1, paddingTop: 1 }} data-testid={entry.uuid}>
          <IconButton aria-label="expand row" size="small" onClick={() => setRowOpen(!rowOpen)}>
            {rowOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>
        <TableCell data-testid={entry.superuser_email} component="th" scope="entry" size="small">
          {entry.superuser_email}
        </TableCell>
        <TableCell type="date" size="small">
          {" "}
          {getDate(entry.occurred_at)}{" "}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: "none" }} colSpan={3}>
          <Collapse in={rowOpen}>
            <Stack padding={2}>
              <Typography variant="body2" fontSize={11} color="rgba(0, 0, 0, 0.6)">
                Changes
              </Typography>
              <JSONPretty data={entry.after} label="Changes" themeClassName="custom-json-pretty"></JSONPretty>
              <Typography variant="body2" fontSize={11} color="rgba(0, 0, 0, 0.6)">
                Before
              </Typography>
              <JSONPretty data={entry.before} label="Before" themeClassName="custom-json-pretty"></JSONPretty>
            </Stack>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export const ChangelogReact = (props) => {
  const entries = props.entries;

  return (
    <TableContainer>
      <Table>
        <colgroup>
          <col style={{ width: "10%" }}></col>
          <col style={{ width: "45%" }}></col>
          <col style={{ width: "45%" }}></col>
        </colgroup>
        <TableHead>
          <TableRow>
            <TableCell size="small" />
            <TableCell size="small">Superuser Email</TableCell>
            <TableCell size="small">Occurred At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.map((entry) => (
            <ChangelogReactRow key={entry.uuid} entry={entry} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
